/**
 * Created by Mark on 24/11/2016.
 */

import BaseStore from './base-store.js';
import Constants from '../constants/classes.js';
import Class from '../classes/class.js';

class ClassesStore extends BaseStore {

    constructor() {
        super();
        this.subscribe(() => this._registerToActions.bind(this));
        this.classes = [];
        this.names = [];
    }

    _registerToActions(action) {


        switch(action.actionType)
        {
            case Constants.UPDATE_CLASSES:

                this.classes = action.response.map(function(__class){
                    var c = new Class(__class.uid , __class.name , __class.students);
                        c.words = __class.words ? __class.words : 0;
                    return c;
                });

                this.emitChange();
                break;
            case Constants.UPDATE_NAMES_CLASSES_LIST:
                console.log(action.response)
                this.names = action.response;
                this.emit("UPDATE_NAMES_CLASSES_LIST");
                break;
            case Constants.UPDATE_CLASS:
                this.class = action.response;
                this.emit("UPDATE_CLASS");
                break;
            case Constants.UPDATE_CLASS_ACTIVITY:
                this.classActivity = action.response;
                this.emit("UPDATE_CLASS_ACTIVITY");
                break


        }


    }

}

export default new ClassesStore();


// WEBPACK FOOTER //
// ./src/store/classes-store.js